export const COLOR_DEC_APURADO = "#1f6fb2";
export const COLOR_FEC_APURADO = "#7fbde3";
export const COLOR_DEC_LIMITE = "#c1272d";
export const COLOR_FEC_LIMITE = "#f08c1e";
export const COLOR_DGC = "#5b2a86";